import { render } from "./CustomSelectOneHorseClassification.vue?vue&type=template&id=914e0efe"
import script from "./CustomSelectOneHorseClassification.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneHorseClassification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__